import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererParams } from 'ag-grid-community';
import { UpdateDeviceListComponent } from '../../../Dialogs/update-device-list/update-device-list.component';
import { CommonModule } from '@angular/common';
import { DeviceService } from '../../../services/device-service/device.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-button-cell-renderer-device-list',
  standalone: true,
  imports: [MatIconModule,CommonModule],
  template: ` <button #actionButton *ngIf="this.params" [disabled]="isButtonDisabled" [style.cursor]="isButtonDisabled ? 'not-allowed' : 'pointer'" [style.opacity]="isButtonDisabled ? '0.5' : '1'" style="border: none; background: transparent;"  (click)="onClick()">
  <mat-icon>edit</mat-icon>
</button>`,
  styles: ``
})
export class ButtonCellRendererDeviceListComponent implements ICellRendererAngularComp,AfterViewInit,OnInit  {
public params: any;
selectedCheckboxDeviceId: any;
toastShown:boolean = false;
@ViewChild('actionButton') actionButton!: ElementRef<HTMLButtonElement>;
checkboxSelected: number = 1; // Default to 1 to match service initial value

ngOnInit(): void {
  this.deviceService.checkboxData.subscribe(data=>{
    console.log('length is',data)
    this.checkboxSelected = data;
    this.cdr.detectChanges(); // Ensure UI updates
  })
}
ngAfterViewInit() {
  if (this.actionButton) {
    // this.actionButton.nativeElement.focus(); // Focusing might scroll unwantedly or steal focus
  }
}

  constructor(private dialog: MatDialog,private deviceService:DeviceService,private toaster:ToastrService, private cdr: ChangeDetectorRef) {}
  
  get isButtonDisabled(): boolean {
    // Disable only if more than 1 item is selected
    return this.checkboxSelected > 1;
  }

  agInit(params: any): void {
    this.params = params;
    this.selectedCheckboxDeviceId = params.selectedCheckboxDeviceId || [];
    // console.log("selectedCheckboxDeviceId ",this.selectedCheckboxDeviceId)
  }

  // refresh(params: ICellRendererParams): boolean {
  //   return false;
  // }
  refresh(params: any): boolean {
    this.params = params;
    this.selectedCheckboxDeviceId = params.selectedCheckboxDeviceId || [];
    return false;
  }

  onClick(): void {
    // Deselect the current row before opening the dialog
    // this.params.node.setSelected(false);

    if(!this.isButtonDisabled)
    {
      const dialogRef = this.dialog.open(UpdateDeviceListComponent, {
        width: '90%',
        data: {
          rowData: this.params.node.data || [],
          // If 0 or 1 selected, passing selectedCheckboxDeviceId is fine if it matches, 
          // but for single edit via pencil, we primarily care about the clicked row.
          // Passing params.node.data.id ensures we have at least the current row ID.
          selectedIds: (this.selectedCheckboxDeviceId && this.selectedCheckboxDeviceId.length > 0) ? this.selectedCheckboxDeviceId : [this.params.node.data.id]
        },
        restoreFocus: false,
        closeOnNavigation: false,
      });

      dialogRef.afterClosed().subscribe(result => {
        document.body.removeAttribute('inert');
        // Refresh the grid if update was successful
        if (result && result.success) {
          this.params.api.setDatasource(this.params.api.getGridOption('datasource'));
        }
      });
    }
    else
    {
      // if (!this.toastShown) {
      //   this.toaster.error(
      //     "Single device can be Editable cannot edit multiple devies",
      //     "",
      //     { timeOut: 1000 }
      //   );
      //   this.toastShown = true;

      //   setTimeout(() => this.toastShown = false, 1500);
      // }
      if (!this.toastShown) {
        this.toaster.error(
          'Multiple devices selected — use "Bulk Edit Devices" button.<br/>Pencil icon applies to a single device only.',
          '',
          { timeOut: 3000, enableHtml: true }
        );
        this.toastShown = true;

        setTimeout(() => this.toastShown = false, 3000);
      }
    }
    // const dialogRef = this.dialog.open(UpdateDeviceListComponent, {
    //   width: '90%',
    //   data: {
    //     rowData: this.params.node.data || [],
    //     selectedIds: this.selectedCheckboxDeviceId
    //   },
    //   restoreFocus: false
    // });
    // this.params.node.setSelected(false);

    // dialogRef.afterClosed().subscribe(result => {
    //   document.body.removeAttribute('inert');
    //   // Refresh the grid if update was successful
    //   if (result && result.success) {
    //     this.params.api.setDatasource(this.params.api.getGridOption('datasource'));
    //   }
    // });
  }
}
